import React, { useEffect, useState } from "react";
import ArrowDown from ".//..//..//..//..//..//assets//images//icons//arrow-down.svg";
import InputTextSimple from "../../../../../components/common/InputText/InputTextSimple";
import "./TetellistaItemCal.css";
import CheckBoxWithOutLabel from "../../../../../components/common/checkbox/CheckboxWithoutLabel";
import ItemCreateModal from "../ItemCreateModal";
import ButtonOutlineFluid from "../../../../../components/common/buttons/ButtonOutlineFluid";
import ButtonFluid from "../../../../../components/common/buttons/ButtonFluid";
import InputTextSimpleTiny from "../../../../../components/common/InputText/InputTextSimpleTiny";
import { useDispatch, useSelector } from "react-redux";
import { ProposalItemActions } from "../../../../../store/Slice/ProposalItemSlice";
import InputNumbersSimpleTinyTB from "../../../../../components/common/InputText/InputNumbersSimpleTinyTB";
import PackingMaterialCreateModal from "../PackingMaterialCreateModal";

const TetellistaItemCal = ({ item, index, saveProposalItems2 }) => {
  const [activeZone, setActiveZone] = useState();

  //
  const [capacity, setCapacity] = useState(77);
  const [amount, setAmount] = useState(220);
  const [products, setProducts] = useState();
  const [displayItems, setDisplayItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();

  const zones = useSelector((state) => state.proposalItems.zones);
  const prackingMaterials = useSelector(
    (state) => state.proposalItems.packingMaterialsInit
  );
  console.log(prackingMaterials);

  useEffect(() => {
    if (zones.length > 0) {
      setActiveZone(zones[0]);
    }
  }, [zones]);

  useEffect(() => {
    if (item) {
      const loadedItems = item.items;
      if (loadedItems.length > 0 && activeZone != undefined) {
        const items = loadedItems.filter((item) => {
          return item.zone_id == activeZone?.id;
        });
        setDisplayItems(items);
        // setFilteredItems(items);
      }
    }
  }, [item, activeZone]);

  const gegenstandgegChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    console.log(updatedItem);
    updatedItem.gegenstand = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.gegenstandgegChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };
  const entladenChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    updatedItem.entladen = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.entladenChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };
  const demontageChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    updatedItem.demontage_checked = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.demontageChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };
  const montageChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    updatedItem.montage_checked = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.montageChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };
  const einpackenChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    updatedItem.einpacken_checked = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.einpackenChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };

  const luftpolsterfolChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    updatedItem.luftpolsterfol_checked = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.luftpolsterfolChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };

  const auspackenChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    updatedItem.auspacken_checked = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.auspackenChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };

  const entsorgenChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    updatedItem.entsorgen_checked = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.entsorgenChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };

  const einlagernChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    updatedItem.einlagern_checked = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.einlagernChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };

  const schwergutChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    updatedItem.schwergut_checked = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.schwergutChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };

  const nichtZerlegbarChangeHandler = (value, product) => {
    const updatedItem = { ...product };
    updatedItem.nicht_zerlegbar_checked = value;
    updatedItem.item_id = product?.item_id;
    updatedItem.location_id = item?.locationId;

    dispatch(
      ProposalItemActions.nichtZerlegbarChangeHandler({
        locationId: item?.locationId,
        updatedItem,
      })
    );
  };

  const duplicateHandler = (product, index) => {
    dispatch(ProposalItemActions.duplicateItem({ product, index }));
  };

  const packingMtGegenstandChangeHandler = (value, material) => {
    dispatch(
      ProposalItemActions.packingMtGegenstandChangeHandler({
        gegenstand: value,
        material,
      })
    );
  };
  const search = (e) => {
    const search = e.target.value;
    setSearchQuery(search);
  };

  useEffect(() => {
    const filteredData = displayItems?.filter((obj) =>
      obj?.targy_neve?.toLowerCase()?.includes(searchQuery?.toLowerCase())
    );

    setFilteredItems(filteredData);
  }, [searchQuery, displayItems]);
  return (
    <div className="flex flex-row justify-between border-t-[1px] pt-6 border-[#8A8A8A] w-full ">
      <div className="w-[15rem]">
        <h3 className="text-text-primary-color font-lato text-[2rem] font-bold leading-normal">
          Zónák
        </h3>
        <ul className="mt-5  pe-1 overflow-y-auto max-h-[50vh]">
          <li
            onClick={() => {
              const zone = {
                id: 9999,
                nev: "Verpackungsmaterial",
                deleted_at: null,
                created_at: "2024-01-28T23:33:57.000000Z",
                updated_at: "2024-01-28T23:33:57.000000Z",
              };
              setActiveZone(zone);
            }}
            className={`h-[3.25rem] mt-1 rounded-[0.625rem] cursor-pointer hover:bg-[#AB3C1B] hover:text-white  flex px-3 items-center ${
              activeZone?.id == 9999 ? "bg-[#AB3C1B] text-white " : ""
            }`}
          >
            Verpackungsmaterial
          </li>

          {zones && (
            <>
              {zones.map((zone, index) => {
                return (
                  <li
                    onClick={() => {
                      setActiveZone(zone);
                    }}
                    className={`h-[3.25rem] mt-1 rounded-[0.625rem] cursor-pointer hover:bg-[#AB3C1B] hover:text-white  flex px-3 items-center ${
                      activeZone?.id == zone?.id
                        ? "bg-[#AB3C1B] text-white "
                        : ""
                    }`}
                    key={zone?.id}
                  >
                    {zone?.nev}
                  </li>
                );
              })}
            </>
          )}
        </ul>
      </div>
      <div className="w-full overflow-x-auto ms-2 rounded-[0.45rem] bg-[#0655671a]">
        {activeZone?.id != 9999 && (
          <>
            <div className="p-4">
              <div className=" text-text-primary-color font-lato text-[2rem] font-bold leading-normal">
                {activeZone?.nev}
              </div>
              <div className="flex flex-row gap-[1.875rem] mt-4 text-text-primary-color font-lato text-[1.5rem] font-bold leading-normal">
                <span>
                  {item?.capacity} <span className="font-normal">m3</span>
                </span>
                <span>
                  {item?.total} <span className="font-normal">EUR</span>
                </span>
              </div>
            </div>
            <div className="product-list">
              <table className="w-full min-w-[10rem] text-center   item-cal-table ">
                <thead>
                  <tr className="h-20">
                    <th className="align-bottom w-[18rem] ps-4 sticky">
                      <div className="w-[16rem]">
                        <InputTextSimple
                          placeholder={`Tétel keresése`}
                          onChange={search}
                          value={searchQuery}
                        />
                      </div>
                    </th>
                    <th className=" vertical-th">
                      <span>Gegenstand</span>
                    </th>
                    <th className="vertical-th ">
                      <span>Entladen</span>
                    </th>
                    <th className="vertical-th">
                      <span>Demontage</span>
                    </th>
                    <th className="vertical-th ">
                      <span>Montage</span>
                    </th>
                    <th className="vertical-th">
                      <span>Einpacken</span>
                    </th>
                    <th className="vertical-th">
                      <span>Luftpolsterfol.</span>
                    </th>
                    <th className="vertical-th ">
                      <span>Auspacken</span>
                    </th>
                    <th className="vertical-th">
                      <span>Entsorgen</span>
                    </th>
                    <th className="vertical-th">
                      <span>Einlagern</span>
                    </th>
                    <th className="vertical-th ">
                      <span>Schwergut</span>
                    </th>
                    <th className="vertical-th">
                      <span>Nicht zerlegbar</span>
                    </th>
                    <th className="px-10 align-bottom text-end">Zwischensum</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems.map((product, index) => {
                    return (
                      <tr key={index}>
                        <td className="sticky flex items-center justify-between text-start ps-4">
                          <span>{product?.targy_neve}</span>
                          <span className="">
                            <button
                              className="w-6 h-6"
                              onClick={() => duplicateHandler(product, index)}
                            >
                              +
                            </button>
                          </span>
                        </td>
                        <td>
                          <InputNumbersSimpleTinyTB
                            id={`gegenstand-${index}`}
                            name={`gegenstand-${index}`}
                            value={product?.gegenstand}
                            onChange={(e) => {
                              gegenstandgegChangeHandler(
                                e.target.value,
                                product
                              );
                            }}
                          />
                        </td>
                        <td>
                          <InputNumbersSimpleTinyTB
                            value={product?.entladen}
                            id={`entladen-${index}`}
                            name={`entladen-${index}`}
                            onChange={(e) =>
                              entladenChangeHandler(e.target.value, product)
                            }
                          />
                        </td>
                        <td>
                          <CheckBoxWithOutLabel
                            id={`demontage_checked-${index}`}
                            name={`demontage_checked-${index}`}
                            value={`demontage_checked-${index}`}
                            // disabled={product?.entsorgen_checked}
                            onClick={(e) =>
                              demontageChangeHandler(
                                !product?.demontage_checked,
                                product
                              )
                            }
                            checked={product?.demontage_checked}
                          />
                        </td>
                        <td>
                          <CheckBoxWithOutLabel
                            id={`montage_checked-${index}`}
                            name={`montage_checked-${index}`}
                            value={`montage_checked-${index}`}
                            // disabled={product?.entsorgen_checked}
                            onClick={(e) =>
                              montageChangeHandler(
                                !product?.montage_checked,
                                product
                              )
                            }
                            checked={product?.montage_checked}
                          />
                        </td>
                        <td>
                          <CheckBoxWithOutLabel
                            id={`einpacken_checked-${index}`}
                            name={`einpacken_checked-${index}`}
                            value={`einpacken_checked-${index}`}
                            // disabled={product?.entsorgen_checked}
                            onClick={(e) =>
                              einpackenChangeHandler(
                                !product?.einpacken_checked,
                                product
                              )
                            }
                            checked={product?.einpacken_checked}
                          />
                        </td>
                        <td>
                          <CheckBoxWithOutLabel
                            id={`luftpolsterfol_checked-${index}`}
                            name={`luftpolsterfol_checked-${index}`}
                            value={`luftpolsterfol_checked-${index}`}
                            // disabled={product?.entsorgen_checked}
                            onClick={(e) =>
                              luftpolsterfolChangeHandler(
                                !product?.luftpolsterfol_checked,
                                product
                              )
                            }
                            checked={product?.luftpolsterfol_checked}
                          />
                        </td>
                        <td>
                          <CheckBoxWithOutLabel
                            id={`auspacken_checked-${index}`}
                            name={`auspacken_checked-${index}`}
                            value={`auspacken_checked-${index}`}
                            // disabled={product?.entsorgen_checked}
                            onClick={(e) =>
                              auspackenChangeHandler(
                                !product?.auspacken_checked,
                                product
                              )
                            }
                            checked={product?.auspacken_checked}
                          />
                        </td>
                        <td>
                          <CheckBoxWithOutLabel
                            id={`entsorgen_checked-${index}`}
                            name={`entsorgen_checked-${index}`}
                            value={`entsorgen_checked-${index}`}
                            onClick={(e) =>
                              entsorgenChangeHandler(
                                !product?.entsorgen_checked,
                                product
                              )
                            }
                            checked={product?.entsorgen_checked}
                          />
                        </td>
                        <td>
                          <CheckBoxWithOutLabel
                            id={`einlagern_checked-${index}`}
                            name={`einlagern_checked-${index}`}
                            value={`einlagern_checked-${index}`}
                            // disabled={product?.entsorgen_checked}
                            onClick={(e) =>
                              einlagernChangeHandler(
                                !product?.einlagern_checked,
                                product
                              )
                            }
                            checked={product?.einlagern_checked}
                          />
                        </td>
                        <td>
                          <CheckBoxWithOutLabel
                            id={`schwergut_checked-${index}`}
                            name={`schwergut_checked-${index}`}
                            value={`schwergut_checked-${index}`}
                            // disabled={product?.entsorgen_checked}
                            onClick={(e) =>
                              schwergutChangeHandler(
                                !product?.schwergut_checked,
                                product
                              )
                            }
                            checked={product?.schwergut_checked}
                          />
                        </td>
                        <td>
                          <CheckBoxWithOutLabel
                            id={`nicht_zerlegbar_checked-${index}`}
                            name={`nicht_zerlegbar_checked-${index}`}
                            value={`nicht_zerlegbar_checked-${index}`}
                            // disabled={product?.entsorgen_checked}
                            onClick={(e) =>
                              nichtZerlegbarChangeHandler(
                                !product?.nicht_zerlegbar_checked,
                                product
                              )
                            }
                            checked={product?.nicht_zerlegbar_checked}
                          />
                        </td>
                        <td className="px-10 break-normal text-end ">{`${product.zwischensum} EUR`}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div>
              <div className="w-full mb-5 lg:w-1/2 me-5 ms-auto">
                <div className="grid grid-col-1 lg:grid-cols-2 mt-[3.75rem]  gap-[1.625rem] text-[1rem] sm:text-[1.25rem] font-lato font-bold">
                  <div className="w-full">
                    <ItemCreateModal />
                  </div>
                  <div className="w-full">
                    <ButtonFluid
                      label={`Mentés`}
                      onClick={saveProposalItems2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {activeZone?.id == 9999 && (
          <>
            <div className="p-4">
              <div className=" text-text-primary-color font-lato text-[2rem] font-bold leading-normal">
                {activeZone?.nev}
              </div>
            </div>
            <div className="packing-list">
              <table className="w-full min-w-[10rem] text-center   item-cal-table ">
                <thead>
                  <tr className="h-20">
                    <th className="px-10 text-start">Verpackungsmaterial</th>
                    <th className="w-[12rem] vertical-th">Gegenstand</th>
                    <th className="w-[12rem]  vertical-th">Zwischensum</th>
                  </tr>
                </thead>
                <tbody>
                  {prackingMaterials
                    .find(
                      (location) => location.location_id === item?.locationId
                    )
                    .materials.map((material, index) => {
                      return (
                        <tr key={index}>
                          <td className="break-normal text-start">
                            <span className="px-10">
                              {material?.verpackungs_material}
                            </span>
                          </td>
                          <td className="px-1 text-center break-normal ">
                            <InputNumbersSimpleTinyTB
                              id={`gegenstand-${index}`}
                              name={`gegenstand-${index}`}
                              value={material?.gegenstand}
                              onChange={(e) => {
                                packingMtGegenstandChangeHandler(
                                  e.target.value,
                                  material
                                );
                              }}
                            />
                          </td>
                          <td className="break-normal text-end ">
                            <span className="px-10">
                              {" "}
                              {material?.zwischensum}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div>
              <div className="w-full mb-5 lg:w-1/2 me-5 ms-auto">
                <div className="grid  mt-[3.75rem]  gap-[1.625rem] text-[1rem] sm:text-[1.25rem] font-lato font-bold">
                  <div className="w-full">
                    <PackingMaterialCreateModal
                      saveItems={saveProposalItems2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TetellistaItemCal;
